"use client"

import dynamic from "next/dynamic"
import { usePathname } from "next/navigation"
import { type ReactNode } from "react"
import Footer from "@/app/components/layout/Footer"

const Header = dynamic(() => import("@/app/components/layout/Header"), { ssr: false })
const MobileBottomNav = dynamic(() => import("@/app/components/layout/MobileBottomNav"), { ssr: false })
const ScrollToTop = dynamic(
  () => import("@/app/components/layout/ScrollToTop").then((mod) => mod.ScrollToTop),
  { ssr: false }
)

export default function AppChrome({ children }: { children: ReactNode }) {
  const pathname = usePathname()

  const isAdmin = pathname.startsWith("/admin")

  if (isAdmin) {
    return (
      <>
        {children}
        <ScrollToTop />
      </>
    )
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div className="flex-1 pb-20 md:pb-10">{children}</div>
      <MobileBottomNav />
      <Footer />
      <ScrollToTop />
    </div>
  )
}
